import { render, staticRenderFns } from "./pieceWise.vue?vue&type=template&id=65338550&scoped=true"
import script from "./pieceWise.vue?vue&type=script&lang=js"
export * from "./pieceWise.vue?vue&type=script&lang=js"
import style0 from "./pieceWise.vue?vue&type=style&index=0&id=65338550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65338550",
  null
  
)

export default component.exports